import React, {useState, useEffect, useRef} from 'react'

import classes from './PopupChapterEnd.module.css'
import Popup from '@/components/shared/Popup/Popup';
import PopupsManager from 'react-sdk/PopupsManager';
import AppState, { POPUPS } from '@/js/AppState';
import Button from '@/components/shared/Button/Button';
import Chapter from '@/js/Chapter';
import Texts from 'react-sdk/Texts';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';


const PopupChapterEnd = ({}) => {

  const [hidden, setHidden] = useState(false)
  /** @type {Chapter} */
  let chapter = PopupsManager.getData(POPUPS.CHAPTER_END)

  function openLeaderBoard() {
    setHidden(true)
    PopupsManager.open(POPUPS.LEADERBOARD, null, () => setHidden(false))
  }
  let btn_text_id = chapter.id == "3" ? "end-chapter-finish" : "end-chapter-continue-btn"
  return (
    <Popup className={clsx(classes.PopupChapterEnd, hidden && classes.hidden)} >
      <div className={classes.PopupContent}>

        <div className={classes.PopupTexts}>
          <h1 className={classes.PopupTitle}>{chapter.endTitle}</h1>
          <div className={classes.PopupDescription} dangerouslySetInnerHTML={{__html: chapter.endText}} />
        </div>

        <div className={classes.ButtonsContainer}>
          {!AppState.leaderboardDisabled &&
          <Button className={classes.LeaderboardButton} onClick={() => { openLeaderBoard() }}>{Texts.get("end-chapter-leaderboard-btn")}</Button>}
          <Button
          className={classes.ContinueButton}
          onClick={() => { PopupsManager.close(POPUPS.CHAPTER_END) }}>
            {Texts.get(btn_text_id)}
          </Button>
        </div>

      </div>

        <div className={classes.chars_ctnr} >
          <img className={classes.chars} src={"data/images/LP_persos.png"} />
        </div>
    </Popup>
  );
};

export default observer(PopupChapterEnd);
